import { HttpErrorResponse } from "@angular/common/http";
import { throwError } from "rxjs";

export default function handleError(error: HttpErrorResponse) {
    let messageError: string;
    switch (error.status) {
        case 0:
            // A client-side or network error occurred. Handle it accordingly.
            console.error("An error occurred:", error.error);
            (messageError = "Problème de connexion Internet, Vérifier que vous êtes connecté"), error.error;
            break;

        case 401:
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(`Backend returned code ${error.status}, body was: `, error.error);
            messageError = "Identifiant ou mot de passe incorrect.";
            break;

        case 400:
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(`Backend returned code ${error.status}, body was: `, error.error);
            messageError = String(error.status);

            break;

        case 404:
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(`Server returned code ${error.status}, body was: `, error.error);
            messageError = String(error.status);

            break;

        default:
            messageError = "Erreur, réessayer plus tard";
    }

    // Return an observable with a user-facing error message.
    return throwError(messageError);
}
